import React from "react";
import {
  Container,
  Button,
  InputLabel,
  MenuItem,
  Select,
} from "@material-ui/core";
import {P1, P2, P3} from 'assets/fonts';


class DemoInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      age: null,
      agePicker: []
    };
  }

  componentDidMount = () => {
    const agePicker = [];
    for (let i=18; i<=120; i++){
      agePicker.push(i);
    }
    this.setState({ agePicker });
  }

  handleAgeChange = (e) => {
    this.setState({ age: e.target.value });
  }

  renderButton = () => {
    const { age } = this.state;
    if (age !== null) {
      return (
        <Button
          variant="contained"
          size="large"
          style={{
            width: 100,
            margin: 10,
            color: "white", backgroundColor: "#107896"
          }}
          onClick={() => this.props.handleClick(this.state.age)}
        >
          Next
        </Button>
      );
    } else {
      return (
        <Button
          variant="contained"
          size="large"
          style={{
            width: 100,
            margin: 10,
            color: "white", backgroundColor: "#107896"
          }}
          disabled={true}
        >
          Next
        </Button>
      );
    }
  };

  render() {
    const { agePicker, age } = this.state;
    return (
      <Container>
        <div style={{ marginTop: "5%", marginLeft: "5%" }}>
          <div id="age">
            <InputLabel id="label">Age</InputLabel>
            <Select
              labelId="demo-controlled-open-select-label"
              id="demo-controlled-open-select gender"
              value={age}
              onChange={this.handleAgeChange}
            >
              {
                agePicker.length !== 0 ?
                agePicker.map((age) => <MenuItem value={age}>{age}</MenuItem>)
                : null
              }
            </Select>
          </div>
          {this.renderButton()}
        </div>
      </Container>
    );
  }
}

export default DemoInfo;
